const campaign: Record<string, string | Record<string, string>> = {
    delayedTask: 'Generation status',
    generationInProgress: 'Generation in progress',
    generationCompleted: 'Generated',
    generationFailed: 'Generation failed',
};

export default campaign;
